export default __webpack_public_path__ + "static/card-orange-5669431cb5c4a2d47270a0bcbc05d394.png";